// extracted by mini-css-extract-plugin
export default {"mastheadHeight":"60px"};